<div class="px-3 border-round flex-auto">
  <div class="flex gap-5">
    <div class="flex-auto p-fluid">
      <form [formGroup]="form">
        <div class="mb-4">
          <label for="icon" class="block font-medium text-900 mb-2">Icono :</label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i [ngClass]="iconControl.value || 'fa-solid fa-question'" style="color: #0063b9"></i>
            </span>
            <input id="icon" type="text" pInputText [formControl]="iconControl" placeholder="fa-solid fa-phone" />
          </div>
          <div class="flex justify-content-between align-items-center">
            <small class="text-muted">Ej: <code>fa-solid fa-phone</code>, <code>fa-solid fa-house</code></small>
            <a class="text-primary cursor-pointer" href="https://fontawesome.com/v6/search" target="_blank">
              <small class="mr-2">Buscar iconos</small>
              <i class="fas fa-external-link-alt text-sm"></i>
            </a>
          </div>

        </div>
        <div class="mb-4">
          <label for="title" class="block font-medium text-900 mb-2">Título :</label>
          <input id="title" type="text" pInputText formControlName="title" />
          <small *ngIf="form.get('title').invalid && form.get('title').touched" class="p-error">El título es
            requerido</small>
        </div>
        <div class="mb-4">
          <label for="subtext1" class="block font-medium text-900 mb-2">Bajada :</label>
          <input id="subtext1" type="text" pInputText formControlName="subtext1" />
        </div>
        <div class="mb-4">
          <label for="subtext2" class="block font-medium text-900 mb-2">Imagen: </label>
          <input id="subtext2" type="text" pInputText formControlName="subtext2" />
        </div>
       
      </form>
    </div>
  </div>
</div>

<div class="flex justify-content-end px-3  gap-2">
  <p-button label="Guardar" (onClick)="save()" [disabled]="form.invalid"></p-button>
</div>